import 'bootstrap/js/dist/modal';
import $ from 'jquery';
import 'slick-carousel';
import YouTubePlayer from 'youtube-player';
import { h, render, Component } from 'preact';
import EasternStoriesOffsiteSlideActivator from '../eastern-stories-offsite-slide/eastern-stories-offsite-slide';

const Nothing = () => null;

class VideoModalContent extends Component {
  componentDidMount() {
    const {player, videoId} = this.props;
    player.loadVideoById(videoId, 0, 'large');
  }

  componentWillUnmount() {
    this.props.player.stopVideo();
  }

  render(props) {
    return (
      <section className='copy-with-call-to-action'>
        <div className='row'>
          <div className='col-12 col-lg-6'>
            <header className='ewu-header'>
              <h2 className="mb-3" id="eastern-stories-modal-label">{props.title}</h2>
              <p>{props.description}</p>
            </header>
          </div>
          <div className='col-12 col-lg-6 call-to-action'>
            <a href={props.link} className='btn btn-primary d-block d-md-inline-block'>
              Read More
            </a>
          </div>
        </div>
      </section>
    );
  }
}

class EasternStories {


  constructor(opts) {
    new EasternStoriesOffsiteSlideActivator();
    this.slideDelay = 500;
    this.getReferences();
    this.setBinds();
    this.initSlides();
    this.imageLoader = opts.imageLoader;
    this.postCache = {};
  }

  /**
  * Get object references
  */
  getReferences() {
    this.$stories = $('.eastern-stories');
    this.$slider = this.$stories.find('.eastern-stories__slides');
    this.$categories = this.$stories.find('.eastern-stories__categories');
    this.$next = this.$stories.find('.eastern-stories__slides-next');
    this.$prev = this.$stories.find('.eastern-stories__slides-prev');
    this.$videoSlides = this.$stories.find('.jsEasternStoryVideo');
    this.$modal = $('#eastern-stories-modal');
    this.root = null;
  }

  /**
  * Set up event binding
  */
  setBinds() {
    this.$categories.on('click', 'a', this.onCategoryClick.bind(this));
    this.$stories.on('click', '.jsEasternStoryVideo', this.handleVideoSlideModal.bind(this));
  }

  /**
   * Stop Video by unmounting component.
   */
  stopVideo() {
    render(<Nothing />, document.getElementById('eastern-stories-modal-content'), this.root);
  }

  handleVideoSlideModal(e) {
    const $this = $(e.currentTarget);
    let videoId = '';
    try {
      const videoUrl = new URL($this.data('video'));
      videoId = videoUrl.searchParams.get('v');
      if (!videoId) {
        throw new Error("videoId parameter not found");
      }
    } catch (e) {
      console.log(e);
    }
    const title = $this.data('title');
    const subheading = $this.data('subheading');
    const link = $this.data('link');
    const description = $this.data('description');

    if (!this.$player) {
      this.$player = YouTubePlayer('eastern-stories-modal-video');
    }
    this.$modal.on('hidden.bs.modal', () => {
      this.stopVideo();
      $this.focus(); // refocus the thing which was clicked on to summon modal
    });

    this.root = render(
      <VideoModalContent
        title={title}
        subheading={subheading}
        link={link}
        description={description}
        player={this.$player}
        videoId={videoId} />,
      document.getElementById('eastern-stories-modal-content')
    );

    this.$modal.modal('show');
  }

  /**
  * Initialze slideshow
  */
  initSlides() {
    this.$slider.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      prevArrow: this.$prev,
      nextArrow: this.$next,
      dots: true,
      dotsClass: 'eastern-stories__slides-pagination',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }
      ]
    });
  }

  /**
  * Remove all slides from the current slider
  */
  removeAllSlides() {
    this.$slider.slick('removeSlide', null, null, true);
  }

  addLoadingSlides() {
    // console.log('add loading slides');

    for (let i = 0, n = 3; i < n; i += 1) {
      this.$slider.slick('slickAdd', '<div class="eastern-stories__slide placeholder"><article><div class="eastern-stories__loader"><span class="eastern-stories__loader-icon fa fa-spinner"></span></div></article></div>');
    }
  }

  /**
  * Request posts from a provided category
  *
  * @param string category
  */

  getCategorySlides(category) {
    return new Promise((resolve) => {
      if (category in this.postCache) {
        resolve(this.postCache[category]);
      } else {
        $.ajax({
          url: `${wp.ajaxUrl}/wp-json/ewu/api/stories`, // eslint-disable-line no-undef
          method: 'get',
          data: {
            category
          }
        }).done((data) => {
          if (data.success) {
            this.postCache[category] = data.posts;
            resolve(data.posts);
          } else {
            resolve([]);
          }
        });
      }
    });
  }

  /**
  * Handle category click
  *
  * @param {*} event
  */
  onCategoryClick(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const $slides = this.$slider.find('.eastern-stories__slide');
    const category = $target.data('category');

    this.$categories.find('a').removeClass('active');
    $target.addClass('active');
    $slides.addClass('loading');

    this.getCategorySlides(category).then((slides) => {
      this.removeAllSlides();
      this.$slider.slick('unslick');
      slides.forEach(($item) => {
        $('.eastern-stories__slides').append($item);
      });

      this.initSlides();
      this.imageLoader.refresh();

    });
  }
}

export default EasternStories;
